import React, { useState, useEffect } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import moment from 'moment'
import { Accordion, AccordionSummary, AccordionDetails} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import './Record.css'
import { getByTitle } from '@testing-library/dom';
import { alpha } from '@mui/material/styles'

const dateComparator = (v1, v2) => moment(v1).diff(moment(v2));

const columns = [
    {
        field: 'log_type',
        headerName: 'Log Type',
        flex: 0.3,
        minWidth: 80,
        hide: false
    },
    {
        field: 'tas_title',
        headerName: 'Activity/CareGiver Name',
        flex: 1,
        minWidth: 150,
        hide: false
    },
    {
        field: 'tas_type',
        headerName: 'Activity Type',
        flex: 0.5,
        minWidth: 100,
        hide: false
    },
    {
        field: 'pro_title',
        headerName: 'Project Name',
        flex: 0.8,
        minWidth: 120,
        hide: false
    },
    {
        field: 'errors',
        headerName: 'Error',
        flex: 2,
        minWidth: 200,
        hide: false,
        renderCell : (params) =>{
            let val = JSON.parse(params.value)
              // console.log(val)
            let tobeDisplayed = Array.isArray(val)?val.map((text, i)=> {
              return <p style={{lineHeight: 1, wordBreak: 'break-word', overflowWrap: 'break-word'}} className='text-wrap mb-0' key={text.message + Math.random()}><span style={{marginRight: 10}} className="badge bg-secondary text-white">{++i}</span>{text.message}</p>
            }):[]
          return (
              // <p className='m-2'>{val.length === 0?'-':val[0].message}</p>
              (<div style={{height: 70, width: '100%', padding: '4px'}} className='d-flex flex-column overflow-auto'>
                  {tobeDisplayed.length === 0?'-':tobeDisplayed}
              </div>)
          );}
    },
    {
        field: 'sched_start_date',
        headerName: 'Scheduled Start Time',
        flex: 0.7,
        minWidth: 140,
        hide: false,
        sortComparator: dateComparator
    },
    {
        field: 'sched_end_date',
        headerName: 'Scheduled End Time',
        flex: 0.7,
        minWidth: 140,
        hide: false,
        sortComparator: dateComparator
    },
    {
        field: 'start_date',
        headerName: 'Start Date/Time',
        flex: 0.7,
        minWidth: 140,
        hide: false,
        sortComparator: dateComparator
    },
    {
        field: 'end_date',
        headerName: 'End Date/Time',
        flex: 0.7,
        minWidth: 140,
        hide: false,
        sortComparator: dateComparator
    },
    {
        field: 'evvmsid',
        headerName: 'EVV MSID',
        flex: 0.5,
        minWidth: 120,
        hide: true,
    },
    {
        field: 'responseCode',
        headerName: 'Response Code',
        flex: 0.3,
        minWidth: 100,
        hide: true
    },
    {
        field: 'transactionId',
        headerName: 'transaction Id',
        flex: 0.5,
        minWidth: 120,
        hide: true,
    },
    {
        field: 'version',
        headerName: 'Version',
        flex: 0.2,
        minWidth: 80,
        hide: true
    },
    {
        field: 'evvId',
        headerName: 'evvID',
        flex: 0.3,
        minWidth: 100,
        hide: true
    },
    {
        field: 'invTimestamp',
        headerName: 'Invocation Timestamp',
        flex: 0.6,
        minWidth: 150,
        hide: true,
        renderCell : (params) =>{
        return (
            !!params.value?moment(params.value).add(moment().utcOffset(), 'minutes').format('MM-DD-YYYY, HH:mm '):'-'
        )},
        sortComparator: dateComparator
    },
];

export default function EvvRecord_v2(props) {

    const [renderTable, setRenderTable] = useState(false);

    useEffect(() => {
        
    }, []);

    var rows = [];
    if(!!props.list.evvLogList){
        rows = props.list.evvLogList.map((log, index) => {
            let filteredTasks = props.tasks.filter(t => t !== undefined)
            
            try{
                return {
                    id: index,
                    log_type: !!log.externalVisitId ? 'Visit' : 'Caregiver',
                    tas_title: filteredTasks.length > 0 ? (!!log.externalVisitId ? filteredTasks.find(t => t.tas_id === log.externalVisitId).tas_title : log.emp_name) : '-',
                    tas_type: filteredTasks.length > 0 ? (!!log.externalVisitId ? filteredTasks.find(t => t.tas_id === log.externalVisitId).tas_type : '-') : '-',
                    pro_title: filteredTasks.length > 0 ? (!!log.externalVisitId ? filteredTasks.find(t => t.tas_id === log.externalVisitId).pro_title : '-') : '-',
                    errors: !!log.errors ? log.errors : [],
                    sched_start_date: filteredTasks.length > 0 ? (!!log.externalVisitId ? moment(filteredTasks.find(t => t.tas_id === log.externalVisitId).tas_start_time, "YYYY-MM-DDTHH:mm:ss").format('LLL') : '-') : '-',
                    sched_end_date: filteredTasks.length > 0 ? (!!log.externalVisitId ? moment(filteredTasks.find(t => t.tas_id === log.externalVisitId).tas_end_time, "YYYY-MM-DDTHH:mm:ss").format('LLL') : '-') : '-',
                    start_date: filteredTasks.length > 0 ? (!!log.externalVisitId ? moment(filteredTasks.find(t => t.tas_id === log.externalVisitId).empLocdate, "YYYY-MM-DDTHH:mm:ss").format('LLL') : '-') : '-',
                    end_date: filteredTasks.length > 0 ? (!!log.externalVisitId ? moment(filteredTasks.find(t => t.tas_id === log.externalVisitId).checkoutEmpDate, "YYYY-MM-DDTHH:mm:ss").format('LLL') : '-') : '-',
                    evvmsid: !!log.evvmsid ? log.evvmsid : '-',
                    responseCode: !!log.responseCode ? log.responseCode : '-',
                    transactionId: !!log.transactionId ? log.transactionId : '-',
                    version: !!log.version ? log.version : '-',
                    evvId: !!log.evvId ? log.evvId : '-',
                    invTimestamp: !!log.invocationTimestamp ? log.invocationTimestamp : '-',
                }
            } catch {
                return {
                    id: index,
                };
            }
        })
    }
    
    function getTitle(){
        let status = <p></p>;
        let numberSummary = <p style={{wordBreak: 'break-word', overflowWrap: 'break-word', margin: '5px 0'}}>CareGiver Records Sent: {props.list.noOfCareGiverRecordsPicked} | CareGiver Records Success: {props.list.noOfCareGiverRecordsSent} | CareGiver Records Failures: {props.list.noOfFailureCareGiverRecords} | Visit Records: {props.list.noOfVisitRecordsPicked} | Visit Records Success: {props.list.noOfSuccessVisitRecords} | Visit Records Failures: {props.list.noOfFailureVisitRecords}</p>
        
        let complete = 1;
        if(!!props.list.evvLogList){
            complete = props.list.evvLogList.find(l => !(l.evvmsid === 'null' && l.evvmsid !== 'N/A (Caregiver)'))
        }
        
        if(props.list.error !== ''){
            status =<b><span style={{float: 'right', wordBreak: 'break-word', maxWidth: '50%'}}><i className='fas fa-exclamation-circle mr-2' style={{color: 'red'}}></i>ERROR: {props.list.error}</span></b>
        } else if(props.list.evvLogList === null){
            status =<b><span style={{float: 'right'}}> <i className='fas fa-times mr-2' style={{color: 'grey'}}></i>THERE WERE NO RECORDS TO SEND</span></b>
        } else if(complete === undefined){
            status =<b><span style={{float: 'right'}}> <i className='fas fa-check-circle mr-2' style={{color: 'green'}}></i>SUCCESSFUL EVV SUBMISSION</span></b>
        } else if(props.list.evvLogList !== null){
            status =<b><span style={{float: 'right'}}> <i className='fas fa-question-circle mr-2' style={{color: '#ffa701'}}></i>INCOMPLETE SUBMISSIONS</span></b>
        }

        return(
            <div style={{width: '100%', overflowWrap: 'break-word', wordBreak: 'break-word'}}>
                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '10px'}}>
                    <b style={{flex: '1', minWidth: '200px'}}>INVOCATION TIMESTAMP: {moment(props.list.invocationTimestamp).format('LLL')}</b>
                    <div style={{flex: '0 0 auto'}}>{status}</div>
                </div>
                {numberSummary}
            </div>
        )
    }

    const onToggle = (expanded) => {
        if(expanded){
            setRenderTable(true);
        } else {
            setRenderTable(false);
        }
    }

    return (
        (<div style={{width: '100%', maxWidth: '100%', margin: 'auto', marginBottom: '20px', overflowX: 'hidden'}}>
            <Accordion onChange={(event, expanded) => onToggle(expanded)} className={'evvLog-accordian'}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    {getTitle()}
                </AccordionSummary>
                <AccordionDetails style={{padding: 0, overflow: 'hidden', width: '100%', maxWidth: '100%'}}>
                    {renderTable && 
                        <div style={{width: '100%', maxWidth: '100%', overflowX: 'auto', boxSizing: 'border-box'}}>
                            <DataGrid
                            initialState={{ density: 'compact' }}
                            rows={rows}
                            columns={columns}
                            pageSize={5}
                            rowHeight={110}
                            autoHeight={true}
                            pageSizeOptions={[5]}
                            disableRowSelectionOnClick
                            showToolbar 
                            slots={{ color: '#3fadf6' }}
                            sx={{
                                width: '100%',
                                maxWidth: '100%',
                                '& .MuiDataGrid-root': {
                                    width: '100%',
                                    maxWidth: '100%',
                                    overflow: 'hidden'
                                },
                                '& .MuiDataGrid-main': {
                                    width: '100%',
                                    maxWidth: '100%',
                                    overflow: 'hidden'
                                },
                                '& .MuiDataGrid-virtualScroller': {
                                    overflowX: 'auto',
                                    overflowY: 'auto'
                                },
                                '& .MuiDataGrid-columnHeaders': {
                                    minWidth: 'fit-content'
                                },
                                '& .MuiDataGrid-row': {
                                    minWidth: 'fit-content'
                                }
                            }}
                            />
                        </div>
                    }
                </AccordionDetails>
            </Accordion>
        </div>)
    );
}